// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Dx-z","smallCardRow":"Ex-z","largeCardRow":"Fx-z","productSearchRow":"Gx-z","curatedRow":"Hx-z"};